export enum AgendaAction {
  Email = 1,
  Llamada = 2,
  Whatsapp = 3,
  Reunion = 4,
  Tarea = 5,
  Escalar = 6
}

export type AgendaItemStatus = "pendiente" | "completado";

export interface AgendaItem {
  itemId: number;
  clienteId: number;
  nombre: string | null;
  deuda: number;
  deudaVencida: number;
  prioridad: number | null;
  ultimaGestion: string | null;
  /** Unknown values must be handled defensively (generic icon). */
  accion: AgendaAction | number;
  accionDetalle: string;
  motivo: string;
  /** Only when accion = Email. */
  asunto: string | null;
  /** LLM output: render as plain text, never as HTML. */
  contenido: string | null;
  /** Only when accion = Tarea. */
  fechaSugerida: string | null;
  status: AgendaItemStatus;
  assignedUserId: number | null;
  completedAt: string | null;
}

export interface AgendaResponse {
  /** yyyy-MM-dd, company-local day. */
  agendaDate: string;
  generated: boolean;
  generatedAt: string | null;
  model: string | null;
  items: AgendaItem[];
}

export type AgendaGenerationOutcome = "generated" | "skipped";

export interface AgendaGenerationResult {
  companyId: number;
  outcome: AgendaGenerationOutcome;
  agendaDate: string;
  clientCount: number;
  model: string | null;
}

/** assignedUserId and clearAssignedUser are mutually exclusive. */
export type AgendaItemUpdateRequest = {
  completado?: boolean | null;
} & (
  | { assignedUserId?: number | null; clearAssignedUser?: never }
  | { assignedUserId?: never; clearAssignedUser: boolean }
);

export interface AgendaInsufficientBalanceError {
  error: "insufficient_balance";
  companyId: number;
  balanceUsd: number;
}
